module.exports = __webpack_public_path__ + "media/images/about-pointimg02-34f30ad16db3bf96a579038aef44cb62.png";